import React from "react";
import "./../../A2Page/A2Page.css";
import A2WhyCard from "../../A2Page/A2Why/A2WhyCard";
import instructor from "./../../../Media/instructor.png";

const C1WhyMain = () => {
  return (
    <div className="a2WhyMainContainer">
      <A2WhyCard
        img={instructor}
        head="Expert  Instructors"
        para="Our C1 German Classes in Bangalore are led by highly experienced and qualified instructors who are native or near-native speakers. Their extensive knowledge of the German language and culture ensures that students receive top-notch education. These experts use proven teaching methods to help students master complex grammar, vocabulary, and idiomatic expressions, essential for advanced proficiency."
      />
      <A2WhyCard
        img={instructor}
        head="Comprehensive Curriculum"
        para="The curriculum for our C1 German Classes in Bangalore is aligned with the Common European Framework of Reference for Languages (CEFR). It covers all language skills—reading, writing, speaking, and listening—in depth. The curriculum includes advanced grammar, extensive vocabulary, and the development of critical thinking and comprehension skills. Our C1 German Classes in Bangalore prepare students for real-world applications and academic or professional challenges."
      />

      <A2WhyCard
        img={instructor}
        head="Interactive Learning Environment"
        para=" We believe in creating an interactive and engaging learning environment. Our C1 German Classes in Bangalore involve group discussions, debates, presentations, and role-plays that simulate real-life scenarios. This approach not only makes learning enjoyable but also ensures that students can confidently use German in various contexts."
      />
      <A2WhyCard
        img={instructor}
        head="Flexible Learning Options"
        para="Understanding the diverse needs of our students, we offer both online and offline C1 German Classes in Bangalore. Whether you prefer the convenience of online classes or the traditional classroom experience, our flexible learning options accommodate your schedule and learning preferences. Both modes of instruction provide the same high-quality education and interactive experience."
      />
      <A2WhyCard
        img={instructor}
        head="Cultural Immersion"
        para="Learning a language is not just about mastering words and grammar; it’s also about understanding the culture. Our C1 German Classes in Bangalore incorporate cultural immersion activities, providing insights into German customs, traditions, and societal norms. This cultural understanding enhances language learning and prepares students for real-world interactions in German-speaking environments."
      />
      <A2WhyCard
        img={instructor}
        head="Personalized Attention"
        para="At Prizma Academy, we understand that each student has unique learning needs. Our C1 German Classes in Bangalore feature small class sizes, allowing for personalized attention from instructors. Students receive regular feedback on their progress and tailored support to address individual challenges. This personalized approach ensures effective learning and helps students achieve their language goals."
      />
      <A2WhyCard
        img={instructor}
        head="Preparation for Certification"
        para="If you aim to obtain a C1 certification, our C1 German Classes in Bangalore offer comprehensive preparation. We provide practice tests, exam strategies, and focused sessions on the skills required for the C1 exam. Our rigorous preparation ensures that students are confident and well-prepared to excel in the certification process, opening up new academic and professional opportunities."
      />
          <A2WhyCard
        img={instructor}
        head="Real-World Applications"
        para="Our C1 German Classes in Bangalore emphasize practical application of the language. Students engage in activities that mimic real-world scenarios, such as business meetings, academic discussions, and social interactions. This practical approach ensures that students can effectively use German in various contexts, enhancing their fluency and confidence."
      />
      <A2WhyCard
        img={instructor}
        head="Success Stories"
        para="The success of our students is a testament to the quality of our C1 German Classes in Bangalore. Many of our alumni have achieved their academic and professional goals, thanks to the strong language foundation they built at Prizma Academy. Whether pursuing higher education, securing employment, or enhancing travel experiences, our students have greatly benefited from their advanced German language skills."
      />
    </div>
  );
};

export default C1WhyMain;
